import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const filters = [
  "All",
  "In Queue",
  "In Progress",
  "GIT",
  "Delay Picking",
  "On Hold",
  "Completed",
  "Canceled",
  "Fake Customer",
];

const StatusTabs = ({ activeStatus, setActiveStatus, onTabChange }) => {
  const navigate = useNavigate();

  const handleFilterClick = (order) => {
    setActiveStatus(order);

    const orderName = order;

    let path = "";
    if (orderName === "All") {
      path = "/orders/all";
    } else if (orderName === "Fake Customer") {
      path = "/orders/fake-customer-order";
    } else {
      path = `/orders/${orderName.toLowerCase().replace(/ /g, "-")}`;
    }

    navigate(path);

    if (onTabChange) {
      onTabChange();
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      {filters &&
        filters.map((filter, index) => (
          <Box
            key={index}
            sx={{
              padding: "9px 18px",
              borderRadius: "4px",
              backgroundColor: filter === activeStatus ? "#ECE9F1" : "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleFilterClick(filter)} // This will now trigger the refresh
          >
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 500,
                color: filter === activeStatus ? "#252525" : "#5D6679",
              }}
            >
              {filter}
            </Typography>
          </Box>
        ))}
    </Box>
  );
};

export default StatusTabs;
